'use client';

import { useEffect } from 'react';
import { CHARTBEAT_CONFIG_SCRIPT_ID, generateChartbeatConfig } from '@benzinga/analytics';
import type { ChartbeatPageview } from '../../_libs/site-shell/pageAnalytics';

let lastPageviewKey = '';

export function resetChartbeatPageviewCache(): void {
  lastPageviewKey = '';
}

function sendChartbeat({ authorName, path, sections, title }: ChartbeatPageview): void {
  if (window.chartbeatLoaded && window.pSUPERFLY) {
    if (window._sf_async_config) {
      window._sf_async_config.authors = authorName;
      window._sf_async_config.sections = sections;
    }
    window.pSUPERFLY.virtualPage({ authors: authorName, path, sections, title });
    return;
  }

  document.getElementById(CHARTBEAT_CONFIG_SCRIPT_ID)?.remove();
  const script = document.createElement('script');
  script.id = CHARTBEAT_CONFIG_SCRIPT_ID;
  script.text = generateChartbeatConfig({
    authorName,
    chartBeatDomain: 'benzinga.com',
    sections: sections ? [sections] : [],
    uid: process.env.CHARTBEAT_KEY as string,
    useCanonical: false,
  });
  document.head.appendChild(script);
}

export function ChartbeatAnalytics({ authorName, path, sections, title }: ChartbeatPageview) {
  useEffect(() => {
    const pageview = { authorName, path, sections, title };
    const key = `${pageview.path}\n${pageview.title}\n${pageview.authorName}\n${pageview.sections}`;
    if (key === lastPageviewKey) return;
    lastPageviewKey = key;
    sendChartbeat(pageview);
  }, [authorName, path, sections, title]);

  return (
    <>
      <link as="script" href="https://static.chartbeat.com/js/chartbeat.js" rel="preload" />
      <script async src="https://static.chartbeat.com/js/chartbeat_mab.js" />
    </>
  );
}
